import AddAppointment from "components/appointment/AddAppointment";
import CheckInButton from "components/common/CheckInButton";
import IncomingCalls from "components/IncomingCallPopup";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "reactstrap";
import { appointmentsSelector } from "slices/appointmentSlice";
import { closeAppointmentPopup, setAddAppointmentPopup } from "slices/appointmentSlice";
import { fetchDashboardAnalytics } from "slices/dashboardSlice";
import { fetchDashboardAppointments } from "slices/dashboardSlice";
import { getCheckInStatus } from "../../slices/userSlice";
import { useTranslation } from "react-i18next";

let userSlice;
function Header(props) {
  const [color] = React.useState("transparent");
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);
  const { user } = useSelector((state) => state.user);
  const [checkinStatus, setCheckinStatus] = useState();
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
  const languageDropdownRef = React.useRef(null);

  const { t, i18n } = useTranslation();

  const languageOptions = [
    {
      code: "en",
      label: "English",
    },
    {
      code: "es",
      label: "Spanish",
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        refDropdown.current &&
        !refDropdown.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }

      if (
        languageDropdownRef.current &&
        !languageDropdownRef.current.contains(event.target)
      ) {
        setLanguageDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleLanguageDropdown = () => {
    setLanguageDropdownOpen((prev) => !prev);
  };

  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
    setLanguageDropdownOpen(false);
  };

  const refDropdown = React.useRef(null);

  useEffect(() => {
    userSlice = require("../../slices/userSlice");
    console.log(userSlice, 'userrrslice');
  }, []);


  useEffect(() => {

    dispatch(getCheckInStatus((success, data) => {
      if (success) {
        console.log("Check-in status fetched successfully", data);
        setCheckinStatus(data.data.user.checked_in);
      } else {
        console.log("Failed to fetch check-in status", data);
      }
    }));
  }, [checkinStatus]);


  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refDropdown.current && !refDropdown.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
  }, [location]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = () => {
    dispatch(userSlice.logout());
    navigate("/login", { replace: true });
  };
  console.log('sadsasaasdasdsadd', user?.user?.checked_in);
  return (
    <>
      <IncomingCalls />
      <Navbar
        expand="lg"
        className={
          location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute border-0 fixed-top"
            : "navbar-absolute border-0 fixed-top " +
            (color === "transparent" ? "navbar-transparent " : "")
        }
      >
        <div className="header">
          <button className="toggle_sidebar" onClick={props.toggleSidebar}>
            <img src="/images/ham.png" alt="" />
          </button>

          <div className="row_user_side">
            <CheckInButton
              initialCheckedIn={checkinStatus}
              role={user?.role}
              internalInterpreter={user?.user?.internal_interpreter}
            />

            <div
              ref={languageDropdownRef}
              className="d-flex align-items-center gap-2 position-relative"
            >
              <button
                className="drop_icon language_switcher_trigger"
                onClick={toggleLanguageDropdown}
                type="button"
                aria-label={t("header.languageSwitcherLabel")}
                title={t("header.languageSwitcherLabel")}
              >
                <i className="fa fa-globe"></i>

                <span className="language_switcher_value">
                  {languageOptions.find((option) =>
                    i18n.language?.startsWith(option.code)
                  )?.label ?? "English"}
                </span>

                <i className="fa fa-chevron-down"></i>
              </button>

              <div
                className={`drop_more_selector language_switcher_dropdown ${
                  languageDropdownOpen ? "language_active" : ""
                }`}
              >
                <div className="language_switcher_header">
                  {t("header.selectLanguage")}
                </div>

                <div className="language_switcher_list">
                  {languageOptions.map((option) => {
                    const isActive = i18n.language?.startsWith(option.code);

                    return (
                      <button
                        type="button"
                        key={option.code}
                        className={`language_switcher_option ${
                          isActive
                            ? "language_switcher_option_active"
                            : ""
                        }`}
                        onClick={() => handleLanguageChange(option.code)}
                      >
                        <span className="language_switcher_option_left">
                          <span className="language_switcher_label">
                            {option.label}
                          </span>
                        </span>

                        {isActive && (
                          <span
                            className="language_switcher_check"
                            aria-hidden="true"
                          >
                            ✓
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            <div ref={refDropdown} className="d-flex align-items-center gap-2 position-relative">
              <button className="user_image" onClick={toggleDropdown}>
                <img src="/images/default-person.png" alt="" />
                <span></span>
              </button>

              <button
                className={`drop_icon ${dropdownOpen ? "active" : ""}`}
                onClick={toggleDropdown}
              >
                <img src="/images/drop.png" alt="" />
              </button>

              <div
                className={`drop_more_selector ${dropdownOpen ? "active" : ""
                  }`}
              >
                <ul>
                  <li>
                    <Link to="/interpreter/profile">{t("header.profile")}</Link>
                  </li>
                  <li>
                    <Link to="/interpreter/change-password">{t("header.changePassword")}</Link>
                  </li>
                  <li>
                    <Link href="#!">{t("header.help")}</Link>
                  </li>
                  <li>
                    <a
                      href=""
                      onClick={handleLogout}
                      className="red_clr"
                    >
                      {t("header.logout")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Navbar>
    </>
  );
}

export default Header;
